import { pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchExternalTransactions = gql`
  query GetTransactionsForAccountId($id: ID!, $first: Int, $after: String) {
    accountR2(id: $id) {
      ... on ExternalPlaidAccount {
        id
      }
      ... on ITransactions {
        transactions(first: $first, after: $after) {
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            cursor
            node {
              id
              ... on ITransaction {
                id
                description
                iconUrl
                shortDescription
                status
                createdAt
                canSeeDetails
                category {
                  name
                }
                caption
                type
                direction
                value {
                  formatted: formattedWithPlusPrefix
                }
                ... on RdcTransaction {
                  confirmationNumber
                  rdcId
                }
                ... on IBankingTransaction {
                  runningBalance {
                    formatted
                  }
                }
              }
            }
          }
        }
      }
      ... on ExternalAccount {
        id
        type
        product
        status
        name
        hasTransactions
        transactions(first: $first, after: $after) {
          pageInfo {
            ...pageInfo
          }
          edges {
            cursor
          }
        }
      }
    }
  }
  ${pageInfo}
`;

export default FetchExternalTransactions;
